import React from "react";
import "./Line.scss";

export const Line = () => <div className="underline"/>
